import dayjs, { type Dayjs } from 'dayjs';
import type { MachineDetailsRobotSchedulePeriod } from '../types/MachineDetailsRobotSchedule.types';

export const getWeekStart = (date: Dayjs = dayjs()): Dayjs => date.startOf('week').startOf('day');

export const getWeekEnd = (date: Dayjs = dayjs()): Dayjs => date.endOf('week').endOf('day');

export const getCurrentWeekPeriod = (): MachineDetailsRobotSchedulePeriod => ({
  startDate: getWeekStart(),
  endDate: getWeekEnd(),
});

export const isRangeSelection = (info: { range?: 'start' | 'end' }): info is { range: 'start' | 'end' } =>
  !!info && typeof info === 'object' && 'range' in info && (info.range === 'start' || info.range === 'end');

export const getSelectedWeekFromRange = (dates: [Dayjs | null, Dayjs | null], range: 'start' | 'end'): Dayjs | null => {
  if (!Array.isArray(dates)) {
    return null;
  }

  const selectedWeek = range === 'end' ? dates[1] ?? dates[0] : dates[0] ?? dates[1];

  return dayjs.isDayjs(selectedWeek) ? selectedWeek : null;
};
